var _mask, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentCCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_11065_1443",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.000213623,
    width: 38,
    height: 39,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 0.000213623,
    width: 38,
    height: 39
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000213623H38V38.0002H0V0.000213623Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 38.0002V37.0002H0V38.0002V39.0002H38V38.0002Z",
    fill: "#D9D9D9",
    mask: "url(#path-1-outside-1_11065_1443)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11065_1443)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(8 8.00021)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19.0002C8 12.9251 12.9249 8.00021 19 8.00021C25.0751 8.00021 30 12.9251 30 19.0002C30 25.0753 25.0751 30.0002 19 30.0002C12.9249 30.0002 8 25.0753 8 19.0002Z",
    fill: "#BAE0FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11065_1443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2324 20.2873H22.3574C22.2988 20.8264 22.1445 21.3088 21.8945 21.7346C21.6445 22.1604 21.291 22.4983 20.834 22.7483C20.377 22.9944 19.8066 23.1174 19.123 23.1174C18.623 23.1174 18.168 23.0237 17.7578 22.8362C17.3516 22.6487 17.002 22.383 16.709 22.0393C16.416 21.6916 16.1895 21.2756 16.0293 20.7912C15.873 20.3029 15.7949 19.76 15.7949 19.1623V18.3127C15.7949 17.7151 15.873 17.174 16.0293 16.6897C16.1895 16.2014 16.418 15.7834 16.7148 15.4358C17.0156 15.0881 17.377 14.8205 17.7988 14.633C18.2207 14.4455 18.6953 14.3518 19.2227 14.3518C19.8672 14.3518 20.4121 14.4729 20.8574 14.7151C21.3027 14.9572 21.6484 15.2932 21.8945 15.7229C22.1445 16.1487 22.2988 16.6428 22.3574 17.2053H21.2324C21.1777 16.8069 21.0762 16.4651 20.9277 16.1799C20.7793 15.8908 20.5684 15.6682 20.2949 15.5119C20.0215 15.3557 19.6641 15.2776 19.2227 15.2776C18.8438 15.2776 18.5098 15.3498 18.2207 15.4944C17.9355 15.6389 17.6953 15.844 17.5 16.1096C17.3086 16.3752 17.1641 16.6936 17.0664 17.0647C16.9688 17.4358 16.9199 17.8479 16.9199 18.301V19.1623C16.9199 19.5803 16.9629 19.9729 17.0488 20.3401C17.1387 20.7072 17.2734 21.0295 17.4531 21.3069C17.6328 21.5842 17.8613 21.8029 18.1387 21.9631C18.416 22.1194 18.7441 22.1975 19.123 22.1975C19.6035 22.1975 19.9863 22.1213 20.2715 21.969C20.5566 21.8166 20.7715 21.5979 20.916 21.3127C21.0645 21.0276 21.1699 20.6858 21.2324 20.2873Z",
    fill: "#2F54EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11065_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 8.00021)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11065_1443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(8 8.00021)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentCCircle);
export default __webpack_public_path__ + "static/media/component-c-circle.71c16023dcd0459cc94deb3486fd0771.svg";
export { ForwardRef as ReactComponent };